import { useParams } from "react-router-dom";

import Heading from "../../shared/ui/Typography/Heading";
import Text from "../../shared/ui/Typography/Text";
import { ClientEditForm } from "../../features/clientEdit";

// ClientEditScreen — route landing for /clients/:clientId/edit.
// Mounts under MainLayout. Thin composition wrapper around the feature
// widget. No selectors, no dispatch, no state — all owned by the
// widget.

function ClientEditScreen() {
  const { clientId } = useParams();

  return (
    <section
      className="feature-client-edit"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <header className="feature-client-edit__header">
          <Heading level={1} variant="page">
            Редагування клієнта
          </Heading>
          <Text as="p" size="sm" tone="secondary">
            Основні поля профілю клієнта: ім'я, контакти, тип, статус і нотатки.
          </Text>
        </header>

        <ClientEditForm clientId={clientId} />
      </div>
    </section>
  );
}

export default ClientEditScreen;
